import React, { Component } from 'react'
import {Form} from 'semantic-ui-react'

export default class Password extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPassword: false
        }
    }

    render() {
        return (
            <Form.Input
                fluid
                {...this.props}
                type={this.state.showPassword ? "text" : "password"}
                action={{
                    icon: (this.state.showPassword ? 'eye' : 'eye slash'),
                    title: 'Show password',
                    onClick: (e) => {this.setState({showPassword: !this.state.showPassword})}
                }}
            />
        )
    }
}
